import { useEffect, useState } from 'react';

const easeOutCubic = (t) => 1 - (1 - t) ** 3;

export const useAnimatedCounter = (target, duration = 1200, enabled = true) => {
  const [value, setValue] = useState(enabled ? 0 : target);

  useEffect(() => {
    if (!enabled) {
      setValue(target);
      return undefined;
    }

    let frameId;
    const start = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      setValue(target * easeOutCubic(progress));
      if (progress < 1) {
        frameId = requestAnimationFrame(tick);
      }
    };

    frameId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frameId);
  }, [target, duration, enabled]);

  return value;
};

export default useAnimatedCounter;
